import React from 'react';
import * as R from 'ramda';
import {LocaleLink} from '@/routes';

const PlanList = ({plans}) => {
  const PlanInfo = ({plan: {id, planNo, productName}}) => (
    <li>
      <LocaleLink to={`/b2c/plan_detail/${id}`}>
        <small>{planNo}</small>
        <p>{productName}</p>
      </LocaleLink>
    </li>
  );

  return R.map(plan => <PlanInfo plan={plan} key={plan.id} />, plans);
};

const PlanCategory = ({plans, color, category}) => (
  <li>
    <p style={{backgroundColor: color}}>{category}</p>
    <ul>
      <PlanList plans={plans} />
    </ul>
  </li>
);

export default PlanCategory;
